/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';


const BOX = 18;

const GRID = 24;


const Glyph = styled.g`
  fill: none;
  stroke: var(--accent-11);

  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
`;


const getTransform = () =>
{
  return `scale(${BOX / GRID}) translate(${- GRID / 2}, ${- GRID / 2})`;
};


export default () =>
(
  <Glyph transform = {getTransform()}>
    <rect x = "5" y = "11" width = "14" height = "9" rx = "2" />
    <path d = "M8 11V8a4 4 0 0 1 8 0v3" />
  </Glyph>
);
